export function normalizeAttendanceFaceApiBaseUrl(value, fallback = '/attendance-face-api/api') {
  const base = String(value || fallback).trim().replace(/\/+$/, '')
  if (!base) return fallback
  return base.endsWith('/api') ? base : `${base}/api`
}

export function normalizeAttendanceFaceServiceBaseUrl(value, fallback = '/attendance-face-api') {
  const base = String(value || fallback).trim().replace(/\/+$/, '')
  if (!base) return fallback
  return base.replace(/\/api$/, '')
}
